import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { PaymentButton } from '@/modules/perseo-billing/components';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import type { IOrderIntentResponse } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { setIsCencoPayTimeOut } from '@/modules/perseo-billing/store/slices/billing';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

import PricesComponent from '../components/prices-component';
import QRContainer from '../components/qr-container';

export default function QRInitialContainer({
  qrCode
}: {
  qrCode: IOrderIntentResponse['qrCode'];
}) {
  const billing = useAppSelector((state) => state.billing);
  const { isCencoPayTimeOut, cencoPayQR } = billing;
  const dispatch = useAppDispatch();

  const { cencoPayGenerateNewCode } = useGtmBillingProduct();

  const handlerSubmit = () => {
    cencoPayGenerateNewCode();
    dispatch(setIsCencoPayTimeOut(false));
  };

  return (
    <>
      {!isCencoPayTimeOut && (
        <Typography
          noWrap
          align="center"
          className="co-overflow-ellipsis co-overflow-hidden !co-text-[16px] co-mb-4"
        >
          Abre la app de CencoPay y escanea el QR o, si prefieres, puedes
          ingresar este código:
          <span className="co-font-bold">{cencoPayQR?.simpleCode}</span>
        </Typography>
      )}
      <QRContainer imageUrl={qrCode} />
      {isCencoPayTimeOut ? (
        <div className="co-pt-[8px] co-pb-[24px]">
          <PaymentButton
            customHandler={handlerSubmit}
            method={'CENCOPAY'}
            label={'Generar un código nuevo'}
          />
        </div>
      ) : (
        <PricesComponent />
      )}
    </>
  );
}
